<template>
  <layouts-guest>
    <base-shadow-card title="ログインパスワードの設定">
      <form @submit.prevent="onSubmit">
        <div class="mb-4">
          <label for="email" class="form-label">{{ t('word.email') }}</label>
          <div class="text-lg">{{ email }}</div>
        </div>
        <div class="mb-4">
          <label for="password" class="form-label">{{ t('word.password_new') }}</label>
          <input
            v-model="password"
            id="password"
            name="password"
            type="password"
            :placeholder="t('word.password_new')"
            :class="`form-input ${errors['password'] ? '!border-red-500' : ''}`"
          >
          <p class="form-error-text">{{ errors['password'] }}</p>
        </div>
        <div class="mb-4">
          <label for="password_confirmation" class="form-label">{{ t('word.password_confirmation') }}</label>
          <input
            v-model="password_confirmation"
            id="password_confirmation"
            name="password_confirmation"
            type="password"
            :placeholder="t('word.password_confirmation')"
            :class="`form-input ${errors['password_confirmation'] ? '!border-red-500' : ''}`"
          >
          <p class="form-error-text">{{ errors['password_confirmation'] }}</p>
        </div>
        <div class="flex items-center justify-between pt-2">
          <base-form-submit :disabled="btnDisabled" text="設定する" />
        </div>
      </form>
    </base-shadow-card>
  </layouts-guest>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import { useRouter, useRoute } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'

import LayoutsGuest from '@/layouts/Guest.vue'
import BaseShadowCard from '@/components/BaseShadowCard.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { ALERT_COLORS } from '@/store/base'

export default defineComponent({
  components: { LayoutsGuest, BaseShadowCard, BaseFormSubmit },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const btnDisabled = ref(false)
    const email = ref('')

    const schema = yup.object({
      password: yup.string().required().min(8).max(255),
      password_confirmation: yup.string().required().oneOf([yup.ref('password'), null], t('validation.password_confirmation')),
    })
    const { handleSubmit, errors } = useForm({ validationSchema: schema })
    const { value: password } = useField<string>('password')
    const { value: password_confirmation } = useField<string>('password_confirmation')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/first/change-password', {
          ...values,
          token: route.params.token
        })
        .then(() => {
          store.commit('base/setAlertMessages', { messages: ['ログインパスワードを設定しました。'], persistent: true, color: ALERT_COLORS.info })
          router.push('/login')
        })
        .finally(() => btnDisabled.value = false)
    })

    onMounted(() => {
      email.value = window.atob(route.query.email as string)
    })

    return {
      t,
      errors,
      password,
      password_confirmation,
      onSubmit,
      btnDisabled,
      email
    }
  },
})
</script>
